import { Component, OnInit, ChangeDetectionStrategy } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { HGSAgentType } from "src/app/constants/agent";
import { Genders } from "src/app/constants/genders";
import { MaskType } from "src/app/constants/masks";
import { TaxStaus } from "src/app/constants/tax-status";
import { USStates } from "src/app/constants/us-states";
import { FormValidationService } from "src/app/services/form-validation.service";

@Component({
    selector: 'mwp-agent-sass-custom-controls',
    templateUrl: './sass-custom-controls.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class SassCustomControlsComponent implements OnInit {

    public verifyForm: FormGroup;
    public maskType = MaskType;
    public genders = Genders;
    public usStates = USStates;
    public hgsAgentType = HGSAgentType;
    public taxStatus = TaxStaus;
    public signatureValid: boolean;

    constructor(
        private formBuilder: FormBuilder,
    ){
    }

    ngOnInit(): void {
        this.verifyForm = this.formBuilder.group({
            verifyInput: [null, Validators.required],
        });
    }

    public cancelSignature(): void {
        this.signatureValid = false;
    }

    public completeSignature(data: Blob): void {
        this.signatureValid = !!data;
    }
}